// extracted by mini-css-extract-plugin
module.exports = {"actionButtonsContainer":"ReferralSources_actionButtonsContainer__3fm1H","actionColumn":"ReferralSources_actionColumn__1by_1","textButton":"ReferralSources_textButton__1Y_mI"};